module.exports = __webpack_public_path__ + "static/media/label.309b0bbd.png";